module.exports = __webpack_public_path__ + "static/media/bib-logo.8a925017.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bib-logo.svg
// module id = 501
// module chunks = 0